import { debounce } from 'lodash';
import {
    action,
    observable
} from 'mobx';

export const DEFAULT_VALIDATION_DEBOUNCE_TIME = 2500;

export interface IValidationPostEditStore {
    readonly showValidationMessage: boolean;
    hide(): void;
    show(): void;
    handleBlur(): void;
    handleEdit(): void;
}

export class ValidationPostEditStore {
    @observable
    showValidationMessage: boolean = false;

    constructor(
        private readonly debounceTime = DEFAULT_VALIDATION_DEBOUNCE_TIME
    ) {
    }

    @action.bound
    hide() {
        if (!this.showValidationMessage) {
            return;
        }

        this.showValidationMessage = false;
    }

    @action.bound
    show() {
        if (this.showValidationMessage) {
            return;
        }

        this.showValidationMessage = true;
    }

    @action.bound
    handleBlur() {
        this.show();
    }

    @action.bound
    handleEdit() {
        this.hide();
        const debouncedShow = debounce(this.show, this.debounceTime);
        debouncedShow();
    }
}


// WEBPACK FOOTER //
// ./src/stores/validation/validation-post-edit-store.tsx